module.exports = __webpack_public_path__ + "static/media/Kerstkaart2019.1ecc25e5.jpg";